import React, { useEffect } from "react"
import { useOktaAuth } from '@okta/okta-react'
import { observer } from "mobx-react"
import { useStores } from '../../hooks/useStores'
import Button from  "@material-ui/core/Button" 
import DropdownMenu from "./DropdownMenu"
import { Link, useNavigate } from 'react-router-dom'
import dropdownIcon from '../../assets/dropdown.png'

const ROUTES_TO_SHOW_SELECTORS = [ 'templates', 'permissions', 'alias-user-management' ]

const NavigationBar = observer(() =>  {

  const { organizationStore, permissionsStore } = useStores()

  const navigate = useNavigate()
  const { oktaAuth, authState } = useOktaAuth()

  if (!authState) return null;

  const login = async () => navigate('/login')
  
  const logout = async () => oktaAuth.signOut()
    
  useEffect(() => {
    let cancelled = false
    ;(async () => {
      await organizationStore.fetchOrgs()
      const info = await oktaAuth.token.getUserInfo()
      if (!cancelled) {
        permissionsStore.getLoggedInUsersPermissions(info.email)
      }
    })()
    return () => {
      cancelled = true
    }
  }, [])

  const fetchedLoggedInUser = permissionsStore.loggedInUserFetched

  const parsedUrl = window.location.href ? window.location.href.split('/') : null
  const route = parsedUrl && parsedUrl.length > 0 ? parsedUrl[parsedUrl.length -1] : null
  const showSelectors = route ? ROUTES_TO_SHOW_SELECTORS.includes(route) : false

  return (
    <div className="nav-bar">
      <div className="left">
        <div className="title"> 
          <Link to={'/'}> {(process.env.ENVIRONMENT_PRETTY_NAME ? `${process.env.ENVIRONMENT_PRETTY_NAME} - ` : '') + 'Toolkit'} </Link>
        </div>
        <div className="links">
          <Link to={'/templates'}>{"Templates"}</Link>
          <Link to={'/permissions'}>{"Permissions"}</Link>
          <Link to={'/alias-user-management'}>{"Alias User Management"}</Link>
          <Link to={'/create-org'}>{"Create Organization"}</Link>
        </div>
      </div>
      <div className="right">
        {
          showSelectors ?
          <div className="organization-selection">
            <DropdownMenu 
              selected={organizationStore.selected}
              items={organizationStore.orgNames(route)}
              setSelected={organizationStore.setSelected}
              icon={dropdownIcon}
            />
          </div> :
          null
        }
        <div className="login-logout">
          { 
            authState.isAuthenticated ?
              <Button className="logout_button" onClick={logout}>Logout</Button> :
              <Button className="login_button" onClick={login}>Login</Button>
          }
        </div>
      </div>
    </div>
  )
})

export default NavigationBar